import React, { useMemo } from 'react';
import startCase from 'lodash/startCase';

import DataGridDyl from '../../../components/DataGridDyl';
import { Button, IconButton } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { LevelText, useLevels } from '@dyl/systems/LevelsManager';
import TaskTypes from "@dyl/task-types";

/**
 * @typedef Props
 * @property {(id: string) => void} removeItem
 */

/**
 * @param {Props & import('@mui/x-data-grid').DataGridProps} props
 */
export default function OutputTaskList({ removeItem, editLink, ...other }) {
    const { globalLevel } = useLevels();

    const columns = useMemo(() => {
        /** @type {import('@mui/x-data-grid').GridColDef[]} */
        let columns = [
            { headerName: 'Task ID', field: 'task_id_name', flex: 1, renderCell({ formattedValue, row }) {
                return (
                    <>
                        <TaskEditButton task={row} editLink={editLink} />
                        {formattedValue}
                    </>
                );
            }
            },
            {
                headerName: 'Task Type', field: 'task_type_id', flex: 1,
                valueFormatter({ value }) {
                    return TaskTypes[globalLevel.label].find(t => t.id === value)?.label ?? 'Unknown';
                }
            },
            { headerName: 'Level', field: 'level_id', flex: 1, renderCell({ value }) {
                return <LevelText levelId={value} />;
            }
            },
            { headerName: 'Skill', field: 'skill_id', flex: 1, valueFormatter({ value }) {
                return startCase(value);
            }
            },
        ];

        if (removeItem) {
            columns.push({ headerName: 'Actions', field: 'action_remove', flex: 1, renderCell({ row }) {
                return (
                    <Button
                        style={{ color: '#FF1A1A' }}
                        onClick={() => removeItem(row.task_id)}
                    >
                        Remove
                    </Button>
                );
            }
            })
        }

        // Disable sorting
        columns = columns.map(c => ({ ...c, sortable: false }));

        return columns;
    }, [removeItem]);

    return (
        <DataGridDyl
            columns={columns}
            getRowId={getRowId}
            localeText={lang}
            pageSize={100}
            hideFooter
            disableSelectionOnClick
            disableColumnMenu
            {...other}
        />
    )
}

const getRowId = row => row.task_id;

/** @type {Partial<import('@mui/x-data-grid').GridLocaleText>} */
const lang = {
    noRowsLabel: 'No tasks selected',
};

function TaskEditButton({ task, editLink }) {

    return (
        <IconButton
            component={Link}
            to={editLink(task)}
            target='_blank'
            size="large">
            <EditIcon fontSize='small' />
        </IconButton>
    );
}